import { render, staticRenderFns } from "./OurBankHolidays.vue?vue&type=template&id=0fa27d08&scoped=true"
import script from "./OurBankHolidays.vue?vue&type=script&lang=js"
export * from "./OurBankHolidays.vue?vue&type=script&lang=js"
import style0 from "./OurBankHolidays.vue?vue&type=style&index=0&id=0fa27d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa27d08",
  null
  
)

export default component.exports